import React, {useRef} from 'react';
import {css} from 'emotion';
import Clock from '../images/clock.svg';
import Fecha from '../images/fecha.svg';
import Lugar from '../images/lugar.svg';
import LogoIes from '../images/logo-ies.png';
import LogoIes2x from '../images/logo-ies@2x.png';
import LogoIes3x from '../images/logo-ies@3x.png';
import {useHistory} from 'react-router-dom';

const SectionConfirma = () => {
    const ref = useRef();

    let history = useHistory();

    const submitForm = (e) => {
        e.preventDefault();
        console.log(ref.current.value);
        history.push(`/confirm/${ref.current.value}`);
    };

    return (
        <section
            className={css`
                background-color: #fff;
                padding: 40px 40px 10px 40px;
                text-align: center;
            `}
        >
            <h3>Confirmá tu presencia al Acto de Colación</h3>

            <p
                className={css`
                    line-height: 2;
                `}
            >
                <img
                    src={Fecha}
                    className={css`
                        margin-right: 8px;
                    `}
                    alt="Fecha"
                />{' '}
                Martes 07 de noviembre 19hs
                <br />
                <img
                    src={Lugar}
                    className={css`
                        margin-right: 8px;
                    `}
                    alt="Lugar"
                />{' '}
                Pabellón Argentina | U.N.C. <br/>
                Av. Haya de la Torre s/n
            </p>

            {/* <iframe src="http://alumnos.ies21.com.ar/colacion2008/confirasistegresado.asp" title="dummy" style={{width:'800px',height:'600px'}}></iframe> */}

            <form onSubmit={submitForm}>
                <input ref={ref} type="text" name="idnd" id="idnd" placeholder="DNI" required />

                <button className="boton" href="https://www.ies21.edu.ar" target="_blank" rel="noopener noreferrer" type="submit">
                    CONFIRMAR
                </button>
            </form>
            <p>Fecha límite para confirmar 31/10</p>

            <div
                className={css`
                    max-width: 115px;
                    margin: auto;
                    margin-top: 48px;
                    display:none;
                `}
            >
                <a  href="https://www.ies21.edu.ar" target="_blank" rel="noopener noreferrer">
                    <img
                        src={LogoIes}
                        srcSet={`${LogoIes} 1x, ${LogoIes2x} 2x, ${LogoIes3x} 3x`}
                        alt="IES"
                        className={css`
                            max-width: 115px;
                            width: 100%;
                        `}
                    />
                </a>

            </div>



            <h3
                className={css`
                    display:none;

                `}
            >Horario por Carreras</h3>

            <div
                className={css`
                    margin-top: 50px;
                    /* display: flex;*/
                    display: none;
                    flex-flow: row wrap;
                    flex: 1 100%;
                `}
            >
                <div
                    className={css`
                        text-align: center;
                        width: 100%;
                        @media all and (min-width: 600px) {
                            flex: 1 0 0;
                            order: 1;
                        }
                    `}
                >
                    <div className="sala">Sala 1 - 10:00 hs.</div>
                    Recursos Humanos
                    <br />
                    Comercio Internacional
                    <br />
                    Logística
                    <br />
                    Gestión Contable
                    <br />
                    Marketing
                    <br />
                    Gestión Ambiental
                    <br />
                    Turismo
                    <br />
                    Relaciones Públicas
                </div>
                <div
                    className={css`
                        text-align: center;
                        width: 100%;
                        margin-top: 30px;
                        @media all and (min-width: 600px) {
                            flex: 1 0 0;
                            order: 2;
                            margin-top: 0;
                        }
                    `}
                >
                    <div className="sala">Sala 2 - 18:00 hs.</div>
                    Diseño Gráfico
                    <br />
                    Multimedios
                    <br />
                    Agronegocios
                    <br />
                    Informática
                    <br />
                    Publicidad
                    <br />
                    Videojuegos
                    <br />
                    Higiene y Seguridad
                    <br />
                    Administración de Empresas
                </div>
            </div>

            <img
                src={Clock}
                className={css`
                    margin-right: 8px;
                    display: none;
                `}
                alt="Hora"
            />
            <h4 className={css`
                    display: none;
                `}>IMPORTANTE</h4>
            <p
                className={css`
                    margin: 0;
                    display: none;
                `}
            >
                Los egresados deberán acceder al Zoom 30 minutos antes de comenzar
            </p>
        </section>
    );
};

export default SectionConfirma;
